
var angular:angular.IAngularStatic =  require('angular');

import { Injectable, Inject } from 'ng-metadata/core';
import { getAuthenticationMethods } from '../appConfig/appConfigForward';
import { LoginService } from '../security/login/login.service';
import { JwtUtilService } from '../security/jwtUtil.service'
import { SharedSessionStorage } from '../infra/sharedSessionStorage.service';
import {UserSessionManagerService} from '../security/userSessionManager.service';


@Injectable()
export class LoginIframeService{


    private tryAgain : boolean;
    private url : string;
    private urls : Array<string>;
    private _iframeSilentLoginEnabled : boolean = false;  // static: config/route allows silent login

	constructor(@Inject('$window') private $window: ng.IWindowService,
                @Inject('$q') private $q: ng.IQService,
                private loginService: LoginService,
                private sharedSessionStorage: SharedSessionStorage,
                private jwtUtilService: JwtUtilService,
                private userSessionManagerService: UserSessionManagerService,
                @Inject('$location') private $location: ng.ILocationService) {
	    this.tryAgain = false;
	    this.urls = this.getLoginUrls();
	    this.url = this.urls.shift();
	    for( let i =0 ; i< window.appConfig.authentication.length ;i++){
            //login and account states perform a login so in order to avoid bugs we don't want silent login to send another login request
            if(!this.$location.path().endsWith('/account') && !this.$location.path().endsWith('/login') &&
                window.appConfig.authentication[i]["silent-login-enabled"]==='true'){
                this._iframeSilentLoginEnabled = true;
                break;
            }
        }
	}

	public setTryAgain(tryAgain){
	    this.tryAgain = tryAgain;
    }

    public getTryAgain(){
	    return this.tryAgain;
    }

	public getUrl(){
	    return this.url;
    }

    public advanceToNextUrl(){
	    if(this.urls.length){
            this.url = this.urls.shift();
            this.sharedSessionStorage.setItem('trySilentLogin', 'true');
             this.tryAgain = true;
             return true;
        }else{
	        this.url = undefined;
	        this.tryAgain = false;
	        return false;
        }
    }

    public getLoginUrls(){
        let authenticationMethodArr =  getAuthenticationMethods();
        let silentLoginUrlsArr : Array<string>=[];
        for(let i = 0 ;i < authenticationMethodArr.length ; i++){
            if ( authenticationMethodArr[i].isSilentLoginSupported()){
                if(!this.$location.path().endsWith('/account') && !this.$location.path().endsWith('/login') && 
                window.appConfig.authentication[i]["silent-login-enabled"]==='true'){
                    silentLoginUrlsArr.push(this.loginService.loginUrl(authenticationMethodArr[i].profileName,
                        authenticationMethodArr[i].authenticationSystem,'',true));
                }
            }
        }
        return silentLoginUrlsArr;
    }

    public trySilentLogin() {
        if (!this._iframeSilentLoginEnabled) {
            console.log('[trySilentLogin] disabled in this view');
            return this.$q.resolve(false);
        }

        if (this.$window.location.search.includes('noSilentLogin=true')) {
            console.log('[trySilentLogin] bypass for automation');
            return this.$q.resolve(false);
        }

        return this.userSessionManagerService.whenJwtSyncReady().then(() => {
            const jwt = this.jwtUtilService.getJwtFromLocalStorage();
            const valid = this.userSessionManagerService.isJWTValidForApp(jwt);
            const signedIn = this.jwtUtilService.isSignedIn();

            if (signedIn && valid) {
                console.log('[trySilentLogin] valid JWT; skipping');
                this.sharedSessionStorage.setItem('trySilentLogin', 'false');
                this.tryAgain = false;
                return false;
            }

            console.log('[trySilentLogin] initiating silent login attempt');
            this.sharedSessionStorage.setItem('trySilentLogin', 'false');
            this.tryAgain = true;
            return true;
        });
    }

    public get iframeSilentLoginEnabled(): boolean {
        const flag = this.sharedSessionStorage.getItem('trySilentLogin');
        return flag === 'true' && this.tryAgain === true;
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/loginIframe.service.ts